(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.lalyaCardCyclesReady) return;
    window.lalyaCardCyclesReady = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initCardCycles = (root = document) => {
      root.querySelectorAll('[data-lalya-card-cycle]').forEach((cycle) => {
        if (cycle.dataset.lalyaCycleReady === 'true') return;

        const slides = Array.from(cycle.querySelectorAll('.lalya-card-gallery__slide:not([hidden])'));
        if (slides.length < 2) return;

        cycle.dataset.lalyaCycleReady = 'true';

        let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (activeIndex < 0) {
          activeIndex = 0;
          slides[activeIndex].classList.add('is-active');
        }

        if (reducedMotion) return;

        window.setInterval(() => {
          if (document.hidden) return;
          slides[activeIndex].classList.remove('is-active');
          activeIndex = (activeIndex + 1) % slides.length;
          slides[activeIndex].classList.add('is-active');
        }, 2000);
      });
    };

    initCardCycles();
    document.addEventListener('shopify:section:load', (event) => initCardCycles(event.target));

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) initCardCycles(node);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-language-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeLanguageToggles = () => {
      document.querySelectorAll('[data-mobile-language-switcher]').forEach((switcher) => {
        if (switcher.dataset.bound === 'true') return;

        const button = switcher.querySelector('[data-mobile-language-toggle]');
        const select = switcher.querySelector('select[name="language_code"]');
        if (!button || !select) return;

        switcher.dataset.bound = 'true';
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');

        button.addEventListener('click', (event) => {
          event.preventDefault();
          const nextOption = Array.from(select.options).find((option) => option.value !== select.value);
          if (!nextOption) return;

          select.value = nextOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeLanguageToggles, { once: true });
    } else {
      initializeLanguageToggles();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
